import React from 'react';
import { Popover, Button } from 'antd';

const Card = ({ employee }) => {
  const { emp_id, first_name, last_name } = employee;
  return (
    <div>
      <h3>
        {first_name} {last_name} ({emp_id})
      </h3>
      {/* <blockquote>Nagercoil / Marthandom</blockquote> */}
    </div>
  );
};

const ProfileCard = ({ employee }) => {
  return (
    <Popover content={<Card employee={employee} />} trigger="click">
      <Button type="link" style={{ padding: '0' }}>
        {employee.emp_id ? employee.emp_id : ''}
      </Button>
    </Popover>
  );
};

export default ProfileCard;
